<template>
  <div class="statement-collapse">
    <b-collapse
      :id="`collapse-${statement.type}-${statement.id}`"
      class="w-100"
      :visible="opened"
    >
      <b-row class="mb-3">
        <b-col :cols="4">
          <div>
            <strong>{{ $t('invoices.single.statement.totalAmount') }}</strong>
          </div>
          <div>
            {{
              transactionData.debit ||
              transactionData.credit | currency(currency)
            }}
          </div>
        </b-col>
        <b-col v-if="statement.customer_bank">
          <div>
            <strong>{{
              $t('invoices.single.statement.remittanceBank')
            }}</strong>
          </div>
          <div>{{ statement.customer_bank }}</div>
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col>
          <div>
            <strong>{{ $t('invoices.single.statement.payeeMemo') }}</strong>
          </div>
          <div>
            {{ transactionData.payee_memo }}
            <a
              :href="`//${transactionData.swift_copy}`"
              target="_blank"
              v-if="transactionData.swift_copy"
              v-b-tooltip.hover
              :title="$t('invoices.single.statement.viewCopy')"
              class="download-swift"
            >
              <b-icon-download title font-scale="0.8" />
            </a>
          </div>
        </b-col>
      </b-row>
      <b-row
        class="mb-3"
        v-if="transactionData.invoices && transactionData.invoices.length > 1"
      >
        <b-col :cols="linkedInvoiceCols">
          <div>
            <strong>{{ $t('invoices.single.statement.forInvoices') }}</strong>
          </div>
          <div
            class="d-flex justify-content-between"
            :key="i"
            v-for="(invoice, i) in transactionData.invoices"
          >
            <div class="d-flex-grow">
              <b-link
                :to="{ name: 'invoicesSingle', params: { id: invoice.id } }"
                target="_blank"
                >{{ invoice.reference }}</b-link
              >
              <div class="buyer-names">{{ invoice.buyer }}</div>
            </div>
            <div class="d-flex-grow text-right">
              {{ invoice.value | currency(currency) }}
            </div>
          </div>
        </b-col>
      </b-row>
    </b-collapse>
  </div>
</template>

<script>
export default {
  props: [
    'transactionData',
    'opened',
    'statement',
    'currency',
    'invoiceId',
    'linkedInvoiceCols'
  ]
}
</script>
